import './basic-specimen-card.scss'

import { defineComponent, PropType } from 'vue';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'

import { SpecimenResource } from '@skinsoft/types';
import { specimenSelectors } from '@skinsoft/selectors';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { BASIC_SPECIMEN_CARD_TITLE_CLICKED } from '../../../events';
import { LocalizedString, Touchable } from '@skinsoft/ui';
import { Media } from '@skinsoft/ui/src/item-card/media';

interface DeactivatedFields {
    identifiers?: boolean,
    recolnatId?: boolean,
    title?: boolean,
    specimenType?: boolean
}

export const BasicSpecimenCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sMedia: Media,
        sLocalizedString: LocalizedString,
        sTouchable: Touchable,
    },
    props: {
        specimen: {
            type: Object as PropType<SpecimenResource>,
            required: true
        },
        excludedFields: {
            type: Object as PropType<DeactivatedFields>,
        },
        actionsAvailable: {
            type: Boolean,
            default: false,
        },
        clickableTitle: {
            type: Boolean,
            default: false,
        }
    },
    template: require('./basic-specimen-card.html'),
    data() {
        return {
            titleClickIcon: faExternalLinkAlt,
        }
    },
    computed: {
        mediaId(): string {
            return specimenSelectors.firstMediaId(this.specimen) ?? ''
        },
        identifier(): string {
            return specimenSelectors.identifier(this.specimen, this.getAppLocale())
        },
        title(): string {
            return specimenSelectors.title(this.specimen, this.getAppLocale()) ?? ''
        },
        specimenType(): string {
            return this.$t(`entity.itemTypes.specimen`) as string ?? ''
        },        
        showSpecimenType(): boolean {
            return (this.excludedFields?.specimenType) !== true
        },
        showTitle(): boolean {
            return (this.excludedFields?.title) !== true
        },
    },
    methods: {
        onTitleClicked() {
            if (this.clickableTitle) {
                this.$emit(BASIC_SPECIMEN_CARD_TITLE_CLICKED)
            } else {
                this.$emit('click')
            }
        },
    }
})
